export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  sortField: string;
  sortOrder: string;
  filter:{
    search:string
    status:number
  }
};

export type MasterTableDataType = {
  name: string;
  id: number;
  type: number;
  description: string;
  clinicId: number;
  status: number;
  createdByDate: string; // Format: "YYYY-MM-DD HH:mm:ss"
  createdById: number;
  ip: string;
  typeName: string;
};


export type MasterDataType = {
  id: number;
  ip: string;
  clinicId: number;
  createdById: number;
  description: string;
  name: string;
  status: number;
  type: number;
};



export type SaveResponseType = {};

export type MasterFormDataType = {
  templateName: string;
  ManagementType:{id:number,name:string}|null
  description: string;
  status: number; // 1 for active, 0 for inactive
};

export const initialFormData: MasterFormDataType = {
  templateName: "",
  ManagementType: null,
  description: "",
  status: 1, // Default to active
};
